import { ROUTE } from 'constants/index'
import { createLazyRouteComponent } from 'helpers/createLazyRouteComponent'

const ForceLogin = (store) => ({
  path: ROUTE.FORCE_LOGIN,
  component: createLazyRouteComponent({
    store,
    reducerKey: 'forceLogin',
    loadReducer: () => import('./ForceLoginState'),
    loadComponent: () => import('./ForceLoginContainer'),
  })
})

export default ForceLogin
